var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "775.000000pt",
    height: "147.000000pt",
    viewBox: "0 0 775.000000 147.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,147.000000) scale(0.100000,-0.100000)",
    fill: "#8A68C9",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 740 l0 -720 100 0 100 0 0 90 0 90 120 140 c67 76 124 141 128 144 4 2 101 -101 216 -230 l208 -234 134 0 c74 0 134 2 134 5 0 4 -205 236 -533 602 l-19 22 221 255 c121 140 221 257 221 260 0 3 -60 6 -132 6 l-133 -1 -275 -319 c-151 -176 -278 -320 -282 -320 -5 0 -8 209 -8 465 l0 465 -100 0 -100 0 0 -720z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300 1375 l0 -85 105 0 105 0 0 85 0 85 -105 0 -105 0 0 -85z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4320 868 l0 -593 24 -50 c27 -59 99 -129 159 -154 85 -37 228 -52 316 -35 l31 7 0 78 0 78 -57 6 c-139 15 -197 40 -240 104 -23 34 -23 38 -23 342 l0 309 160 0 161 0 -3 103 -3 102 -157 3 -158 3 0 144 0 145 -105 0 -105 0 0 -592z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5002 1378 l3 -83 103 -3 102 -3 0 86 0 85 -105 0 -106 0 3 -82z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320 595 l0 -575 100 0 100 0 0 575 0 575 -100 0 -100 0 0 -575z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2193 1159 c-209 -35 -386 -190 -455 -399 -20 -60 -22 -90 -26 -402 l-4 -338 106 0 105 0 3 333 3 332 32 66 c143 290 556 272 675 -29 21 -54 22 -75 26 -380 l4 -322 99 0 99 0 0 320 c0 191 -4 340 -11 372 -37 181 -189 357 -360 418 -104 36 -197 45 -296 29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5020 595 l0 -576 103 3 102 3 0 570 0 570 -102 3 -103 3 0 -576z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5830 1154 c-141 -37 -265 -124 -344 -242 -134 -202 -134 -452 1 -655 102 -154 262 -243 453 -254 177 -10 321 46 445 172 39 39 78 85 88 103 l18 32 -126 0 c-126 0 -126 0 -164 -30 -181 -146 -468 -77 -573 138 -31 62 -33 74 -33 167 0 87 3 107 26 156 88 188 297 273 490 200 29 -11 69 -34 90 -51 38 -30 38 -30 164 -30 l126 0 -18 32 c-10 18 -49 64 -88 103 -116 118 -254 175 -420 174 -44 0 -105 -7 -135 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7016 1154 c-108 -26 -184 -70 -272 -158 -121 -122 -174 -246 -174 -411 0 -165 53 -289 174 -411 89 -89 164 -132 277 -159 170 -40 375 6 497 110 l42 37 0 -81 0 -81 90 0 90 0 0 333 c0 366 -4 397 -62 517 -43 89 -168 214 -259 258 -124 60 -274 77 -403 46z m216 -195 c121 -26 217 -103 271 -217 28 -60 32 -77 32 -157 0 -80 -4 -97 -32 -157 -113 -239 -409 -299 -610 -124 -27 24 -56 65 -80 114 -36 71 -38 82 -38 167 0 85 2 96 38 167 79 162 246 244 419 207z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3395 1114 c-123 -8 -262 -25 -312 -40 l-53 -15 0 -84 0 -85 570 0 571 0 -3 87 -3 87 -43 13 c-24 6 -84 17 -135 23 -98 11 -491 20 -592 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3030 560 l0 -110 570 0 570 0 0 110 0 110 -570 0 -570 0 0 -110z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3020 145 c0 -73 1 -76 28 -86 109 -42 461 -67 715 -51 177 11 329 32 381 52 25 9 26 13 26 85 l0 75 -575 0 -575 0 0 -75z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.15a5ffd8861503decd5cd2e6f80f2acf.svg";
export { ForwardRef as ReactComponent };